import { useLayoutEffect, useRef } from 'react';

const useBottomScrollAnchor = ({ containerRef, contentKey, isActive, isPaused = false, thresholdPx = 80 }) => {
    const shouldAnchorToBottomRef = useRef(true);

    useLayoutEffect(() => {
        if (!containerRef.current || isPaused || !shouldAnchorToBottomRef.current || !isActive) return;

        containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }, [containerRef, contentKey, isActive, isPaused]);

    const updateBottomScrollAnchor = (element) => {
        const distanceFromBottom = element.scrollHeight - element.scrollTop - element.clientHeight;
        shouldAnchorToBottomRef.current = distanceFromBottom <= thresholdPx;
    };

    return {
        updateBottomScrollAnchor,
    };
};

export default useBottomScrollAnchor;
